import PropTypes from 'prop-types';
import { isAPDomain } from '@helpers';

import { ExternalLinkIcon, OverlayPopover } from '@utilities';

const DEFAULT_HELP_CENTER_URL = 'http://help.insights.numerator.com/en/';
const VERIFIED_VOICES_HELP_CENTER_URL =
  'https://help.numerator.com/en/collections/3625626-verified-voices-survey';
const VERIFIED_VOICES_MENU_LABEL = 'dashboard_survey';

const HelpDropdown = ({ isHelpDropdownActive, menuLabel, setActiveDropdown, target }) => {
  if (!isHelpDropdownActive) return null;

  const showTrainingLinks = !isAPDomain();
  const helpCenterUrl =
    menuLabel === VERIFIED_VOICES_MENU_LABEL
      ? VERIFIED_VOICES_HELP_CENTER_URL
      : DEFAULT_HELP_CENTER_URL;

  return (
    <OverlayPopover
      data-testid="help-dropdown"
      header="Help"
      isActive={isHelpDropdownActive}
      onHide={() => setActiveDropdown('')}
      target={target}
    >
      <ul>
        <li>
          <a
            href={helpCenterUrl}
            onClick={() => setActiveDropdown('')}
            rel="noreferrer"
            target="_blank"
          >
            <ExternalLinkIcon />
            <span>Help Center</span>
          </a>
        </li>
        {showTrainingLinks && (
          <>
            <li>
              <a
                href="https://learn.numerator.com"
                onClick={() => setActiveDropdown('')}
                rel="noreferrer"
                target="_blank"
              >
                <ExternalLinkIcon />
                <span>Numerator University</span>
              </a>
            </li>
            <li>
              <a
                href="https://learn.numerator.com/pages/22/live-training"
                onClick={() => setActiveDropdown('')}
                rel="noreferrer"
                target="_blank"
              >
                <ExternalLinkIcon />
                <span>Live Training</span>
              </a>
            </li>
          </>
        )}
      </ul>
    </OverlayPopover>
  );
};

HelpDropdown.propTypes = {
  isHelpDropdownActive: PropTypes.bool,
  menuLabel: PropTypes.string,
  setActiveDropdown: PropTypes.func,
  target: PropTypes.object,
};

export default HelpDropdown;
